export type AboutCapability = {
  title: string
  description: string
}

export type AboutContent = {
  documentTitle: string
  h1: string
  intro: string[]
  forWhom: {
    title: string
    paragraphs: string[]
  }
  capabilities: {
    title: string
    items: AboutCapability[]
  }
  howToStart: {
    title: string
    steps: string[]
  }
}

export const aboutContent: AboutContent = {
  documentTitle: 'О проекте',
  h1: 'Площадка для проектов, команд и совместного развития',
  intro: [
    'Прогресс — социальная платформа для людей, которые запускают проекты, собирают команды и развивают идеи вместе с другими.',
    'Здесь можно делиться опытом, находить единомышленников и вести работу от замысла до результата в одном пространстве.',
  ],
  forWhom: {
    title: 'Для кого',
    paragraphs: [
      'Для авторов проектов, участников команд, специалистов и всех, кто хочет находить полезные инициативы и присоединяться к ним.',
      'Платформа подходит и тем, кто только формулирует идею, и тем, кто уже развивает действующий проект.',
    ],
  },
  capabilities: {
    title: 'Что можно делать',
    items: [
      {
        title: 'Проекты',
        description:
          'Публиковать инициативы, описывать цели и результаты, собирать интерес и участие вокруг идеи.',
      },
      {
        title: 'Команды',
        description: 'Создавать и находить команды, приглашать людей и развивать совместную работу.',
      },
      {
        title: 'Соц-заказы',
        description: 'Работать с запросами общества: находить и предлагать решения через соц-заказы.',
      },
      {
        title: 'Инструменты роста',
        description: 'Использовать материалы и практики, которые помогают развивать проект и компетенции.',
      },
      {
        title: 'Люди',
        description: 'Знакомиться с участниками сообщества, подписываться и находить тех, с кем интересно сотрудничать.',
      },
      {
        title: 'События',
        description:
          'Получать уведомления о заявках, приглашениях, комментариях и других важных изменениях.',
      },
    ],
  },
  howToStart: {
    title: 'Как начать',
    steps: [
      'Зарегистрируйтесь или войдите в аккаунт.',
      'Заполните профиль, чтобы вас могли найти другие участники.',
      'Создайте проект или команду — либо присоединитесь к существующим инициативам.',
    ],
  }
}
